import React from "react";
import { Link } from "react-router-dom";
import {
  FaInstagram,
  FaFacebookF,
  FaYoutube,
  FaLinkedinIn,
} from "react-icons/fa6";
import styles from "./Footer.module.css";
import LazyImage from "../LazyImage/LazyImage";
import {
  ifillip_logo as logo,
  Bcpl_logo as bharatCloudsLogo,
} from "../../controller/Image";

const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Why iFillip", to: "/Why-iFillip" },
  { label: "AI Suite", to: "/ai-suite" },
  { label: "Core Features", to: "/core-features" },
];

const ACTION_LINKS = [
  { label: "Request Demo", to: "/book-demo" },
  { label: "Contact", to: "/contact" },
  // { label: "Company", to: "/company" },
  { label: "Blog", to: "/Blog" },
];

const SOCIAL_LINKS = [
  {
    icon: FaInstagram,
    href: "https://www.instagram.com/ifillip_education/",
    label: "Instagram",
  },
  {
    icon: FaFacebookF,
    href: "https://www.facebook.com/ifillipportal/",
    label: "Facebook",
  },
  {
    icon: FaYoutube,
    href: "https://www.youtube.com/@ifillip ", // or your profile when available
    label: "Twitter / X",
  },
  {
    icon: FaLinkedinIn,
    href: "https://www.linkedin.com/products/bharatclouds-ifillip/",
    label: "LinkedIn",
  },
];

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className={`${styles.inner} page-container`}>
        {/* ============ TOP SECTION ============ */}
        <div className="row gy-5">
          {/* Column 1   Brand */}
          <div className="col-12 col-lg-4">
            <Link to="/" aria-label="iFillip home" className={styles.logoLink}>
              <LazyImage
                {...logo}
                alt="iFillip   AI-Powered School Management Software"
                wrapperClassName={styles.logoImg}
              />
            </Link>
            <p className={styles.tagline}>
              Redefining academic outcomes through purposeful AI and intelligent
              school management.
            </p>

            <div className={styles.socials} aria-label="Social media links">
              {SOCIAL_LINKS.map(({ icon: Icon, href, label }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  className={styles.socialLink}
                >
                  <Icon />
                </a>
              ))}
            </div>
          </div>

          {/* Column 2   Links (split into 2 inner cols) */}
          <div className="col-12 col-lg-4">
            <div className="row">
              <div className="col-6">
                <h4 className={styles.colTitle}>Explore</h4>
                <ul className={styles.linkList}>
                  {NAV_LINKS.map((link) => (
                    <li key={link.label}>
                      <Link to={link.to} className={styles.link}>
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="col-6">
                <h4 className={styles.colTitle}>Get Started</h4>
                <ul className={styles.linkList}>
                  {ACTION_LINKS.map((link) => (
                    <li key={link.label}>
                      <Link to={link.to} className={styles.link}>
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          {/* Column 3   Company Info */}
          <div className="col-12 col-lg-4">
            {/* <h4 className={styles.colTitle}>A Product Of</h4> */}
            <div className={styles.companyBlock}>
              <Link to="https://bharatclouds.com" target="_blank">
                {" "}
                <LazyImage
                  {...bharatCloudsLogo}
                  alt="Bharat Clouds"
                  wrapperClassName={styles.companyLogo}
                />
              </Link>

              <p className={styles.companyText}>
                <a
                  href="https://bharatclouds.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.companyLink}
                >
                  Bharat Clouds Private Limited
                </a>{" "}
                is a technology-driven company building AI-powered, cloud-first digital products and platforms for modern businesses and institutions.
              </p>
            </div>
          </div>
        </div>

        {/* ============ BOTTOM SECTION ============ */}
        <div className={styles.bottom}>
          <div className="row align-items-center gy-2">
            <div className="col-12 col-md-8">
              <p className={styles.copy}>
                © {currentYear} Bharat Clouds Private Limited. All rights
                reserved.
              </p>
            </div>
            <div className="col-12 col-md-4">
              <div className={styles.bottomLinks}>
                <Link to="/privacy-policy" className={styles.policyLink}>
                  Privacy Policy
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
